import { IconButton } from "@mui/material";
import React from "react";

export default function CoreIconButton(props) {
  return <IconButton {...props}>{props.children}</IconButton>;
}
